import React from "react";

const Separator: React.FC = () => {
  return <hr style={{ border: "1px solid #ccc", margin: "20px 0" }} />;
};

export default Separator;
